<template lang='pug'>
//- QRcode 分享框
div(:class='$style[`cc-popbox-qrcode`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 專屬
        span.font-doctor-theme 連結
        span.no-wrap 與
        span.font-normal-theme 條碼

    div(:class='$style[`cc-qrcode-content`]')
      div(:class='$style[`cc-share-link`]')
        div(:class='$style[`cc-share-link-wrap`]')
          //- span!= '分享網址:'
          span(:class='$style[`cc-share-link-path`]') {{ link }}

        //- 複製會員連結
        div(:class='$style[`cc-share-link-copy`]' @click='copyUserLink')
          transition(name='animate-slide-up-fade')
            div(
              v-if='showCopyTips'
              :class='$style[`cc-link-copy-tip`]')
              span {{ showCopyMsg }}
          span(:class='$style[`cc-share-link-text`]') 複製連結

      div(:class='$style[`cc-share-qrcode`]')
        div(:class='$style[`cc-share-qrcode-wrap`]')
          img(:src='`${SERVER_DOMAIN}/apiserver/qrcode/?url=${link}`' width='100%' height='100%')
          a(
            download
            target='_blank'
            :href='`${SERVER_DOMAIN}/apiserver/qrcode/?url=${link}.jpg`'
            :class='$style[`cc-share-qrcode-download`]') 下載圖檔

</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    link: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showCopyTips: true,
      showCopyMsg: '',
    };
  },

  methods: {
    ...mapMutations({
      changePopQRcodeStatus: 'global/POPQRCODE_STATUS',
    }),

    handleClosePopBox() {
      this.changePopQRcodeStatus({
        active: false,
        link: '',
      });
    },

    copyUserLink() {
      this.showCopyTips = false;
      this.showCopyMsg = '已複製';

      this.$copyText(this.link)
        .then((/* e */) => {
          this.showCopyTips = true;
        }, (/* e */) => {
          this.showCopyMsg = '複製失敗';
        });
    },
  },
};


</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popQRcode.scss';
</style>
